import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Displays and parses Material datepicker dates as dd-MM-yyyy (display only).
 * The value stored in the form is still a Date; interceptors/components decide
 * how it is serialised for the backend — this only changes what the user sees/types.
 */
@Injectable()
export class DdMmYyyyDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const parts = value.trim().split(/[-/.]/);
      if (parts.length === 3) {
        const d = +parts[0], m = +parts[1], y = +parts[2];
        if (d && m && y) return new Date(y, m - 1, d);
      }
    }
    if (!value) return null;
    const t = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(t) ? null : new Date(t);
  }

  override format(date: Date, _displayFormat: Object): string {
    const d = ('0' + date.getDate()).slice(-2);
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    return `${d}-${m}-${date.getFullYear()}`;
  }
}

export const DD_MM_YYYY_FORMATS = {
  parse: { dateInput: 'DD-MM-YYYY' },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
